import { useRef } from 'react';

import cn from 'classnames';
import { useClickOutside } from 'hooks/click-outside';
import { useClipboard } from 'hooks/clipboard';

import styles from './LinkShare.module.scss';

export const LinkShare = ({ open, link, title, buttonText = 'Copy', onClose = () => {} }) => {
  const shareRef = useRef(null);
  const linkRef = useRef(null);

  useClickOutside(shareRef, onClose);
  const copyToClipboard = useClipboard(linkRef);

  return (
    <div ref={shareRef} className={cn(styles.root, 'u-border', { [styles.disabled]: !open })}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        <a className={styles.copy} onClick={copyToClipboard}>
          {buttonText}
        </a>
      </div>
      <input ref={linkRef} value={link} readOnly />
    </div>
  );
};

export default LinkShare;
